import api from './client';

export const contactsApi = {
  list: (params?: { search?: string; type?: string; page?: number }) =>
    api.get('/contacts', { params }),
  create: (data: any) => api.post('/contacts', data),
  get: (id: number) => api.get(`/contacts/${id}`),
};
